<template lang="pug">
modal(:max-width="1024", v-if="mensaje")
	.card.text-left
		.card-header
			| Enviado el {{ mensaje.cabecera.date | moment('DD-MM-YYYY') }} a las {{ mensaje.cabecera.date | moment('HH:mm:ss') }}
			button.close(@click="cerrar") &times;
		.card-body
			h2
				b {{ mensaje.cabecera.Subject }}
		.card-body
			.cabeceraDatos
				.remitente
					div.imagen(v-if="mensaje.cabecera.avatar")
						img(:src="mensaje.cabecera.avatar", class="rounded-circle", style="width: 50px; height: 50px;")
					div.datos
						b(style="font-size:1.2em;") {{ mensaje.cabecera.from[0].personal }}
						br
						span(style="opacity: 0.5;") {{ mensaje.cabecera.fromaddress }}
				.datosCabecera
					b Destinatario(s)
					br
					div(
						style="color:#555588"
						v-for="(para, i) in mensaje.cabecera.to"
						:key="para.mailbox"
						v-if="i <= 2 || verTodosDestinatarios"
					) {{para.personal}} <{{para.mailbox}}@{{para.host}}>
					div(
						v-if="mensaje.cabecera.to.length > 3"
						style="opacity: 0.5;cursor:pointer;"
						@click="verTodosDestinatarios = !verTodosDestinatarios"
					)
						span(v-if="!verTodosDestinatarios") Ver {{ mensaje.cabecera.to.length - 3 }} destinatarios mas
						span(v-else) Ver menos
		.card-body(v-html="mensaje.cuerpo", style="border-top: 1px solid #e0e0e0;")
		.card-body.bg-light(v-if="adjuntos.length > 0")
			b Adjuntos
			a(ref="descarga", style="display:none;")
			.capaAdjuntos
				.adjunto(v-for="(adjunto, i) in adjuntos", :key="i", @click="download(adjunto.part, adjunto.nombre)")
					span.iconoAdjunto
						span.fa.fa-file-o
					span.nombreAdjunto {{ adjunto.nombre }}
					span.tamanoAdjunto {{ adjunto.size | tamano }}
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	props: ['numero'],
	data () {
		return {
			cuerpo: null,
			cabecera: null,
			estructura: null,
			asunto: 'Vacaciones',
			remitenteNombre: 'Daniel Cañada',
			remitente: 'dcanada@radiocastellon.com',
			verTodosDestinatarios: false
		}
	},
	created () {
		this.verMensaje(this.numero)
	},
	watch: {
		numero: {
			handler: 'verMensaje',
			inmediate: true
		}
	},
	computed: {
		...mapGetters({
			buzonActivo: 'webmail/buzonActivo',
			cuenta: 'webmail/cuenta',
			mensaje: 'webmail/mensaje',
			email: 'webmail/cuenta'
		}),
		adjuntos () {
			// Comprobamos si tiene adjunto
			return this.mensaje.estructura.reduce((hay, part) => {
				if (part.part_object) {
					if (part.part_object.type > 2) {
						for (let i = 0; i < part.part_object.parameters.length; i++) {
							const param = part.part_object.parameters[i]
							if (param.attribute === 'name') {
								hay.push({
									size: part.part_object.bytes,
									nombre: param.value,
									tipo: part.part_object.subtype,
									part: part.part_number
								})
							}
						}
					}
				}
				return hay
			}, [])
		}
	},
	methods: {
		...mapActions({
			verMensaje: 'webmail/verMensaje'
		}),
		download (part, nombre) {
			this.$http.post('webmail/php/api/get-adjunto.php',
				{
					email: this.email,
					buzon: this.buzonActivo.Path,
					numero: this.numero,
					part: part
				},
				{
					responseType: 'blob',
					headers: {
						'Content-type': 'application/json',
						'Accept': 'application/x-binary'
					}
				})
				.then(res => {
					const url = URL.createObjectURL(res.data)
					const a = this.$refs.descarga
					a.name = nombre
					a.href = url
					a.download = nombre
					a.click()
				})
				.catch(e => {
					console.error(e)
				})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
.cabeceraDatos {
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: flex-start;
}
.remitente {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-grow: 1;
	flex-shrink: 1;
	text-align: left;
}
.remitente > .imagen {
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 60px;
}
.remitente > .datos {
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 300px;
}
.datosCabecera {
	flex-grow: 1;
	flex-shrink: 1;
	text-align: right;
}

.capaAdjuntos {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
.adjunto {
	position: relative;
	display: flex;
	flex-direction: column;
	text-align: center;
	max-width: 100px;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 100px;
	margin: 5px;
	cursor: pointer;
}
.adjunto:hover {
	background-color: #e0e0e0;
}

.iconoAdjunto {
	font-size: 2em;
	margin-bottom: 5px;
}

.nombreAdjunto {
	font-weight: bold;
}
.tamanoAdjunto {
	opacity: 0.6;
}
</style>




// WEBPACK FOOTER //
// src/modulos/webmail/vue/components/mensajes/visorMensaje.vue